import React from 'react';

import { transformWithPrefix } from 'helpers/string';

import cx from 'classnames';
import styles from './styles.scss';

export default class MomentWarning extends React.PureComponent {
  render() {
    const { className, rotate } = this.props;
    const classes = cx(styles.warning, className);

    const style = {
      [transformWithPrefix]: rotate ? `translateX(-50%) rotate(${360 - rotate}deg)` : null,
    };

    return (
      <div className={classes} style={style}>
        <div className={styles.marker}>!</div>
        <div className={styles.messageWrapper}>
          <div className={styles.message}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/moment-warning/index.js